<template>
    <v-dialog v-model="mostrar" persistent max-width="500px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Nueva dependencia / área</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="nombre" 
                                name="SG-ND-nombre" 
                                label="Nombre:"
                                :error-messages="errors.nombre"
                                @input="validarNombre()"
                                @blur="validarNombre()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-select 
                                v-model="tipoSel"
                                :items="tipos"
                                label="Tipo"
                            />
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field 
                                v-model="numero" 
                                name="SG-ND-numero" 
                                label="Número:"
                                :error-messages="errors.numero"
                                @input="validarNumero()"
                                @blur="validarNumero()"
                                :disabled="tipoSel == 'area'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                :items="usuarios"
                                v-model="titular"
                                label="Titular:"
                                item-text="nombreCompleto"
                                item-value="_id"
                                :filter="customFilter"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="puesto" 
                                name="SG-ND-puesto" 
                                label="Puesto:"
                                :error-messages="errors.puesto"
                                @input="validarPuesto()"
                                @blur="validarPuesto()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="blue-grey darken-1" dark @click="guardarDependencia()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'

export default {
    props:['mostrar'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        nombre: null,
        tipos:[
            {value:'area',text:'Área'},
            {value:'comision',text:'Comisión'}
        ],
        tipoSel: 'area',
        numero: 'I',
        titular: null,
        puesto: null,
        usuarios: [],
        errors:{
            nombre: [],
            puesto: [],
        },
    }),
    validations: {
        nombre: { required, minLength: minLength(5) },
        numero: { required },
        puesto: { required, minLength: minLength(5) },
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    watch:{
        tipoSel(nuevo, anterior){
            if( !this.numero)
                this.numero = 'I'
        }
    },
    created(){
        this.loading = true;
        axios.get(this.httpURL+'/dependencias/usuarios',
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.usuarios = res.data.usuarios;
                    this.titular = this.usuarios[0]._id;
                    this.loading = false;
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    this.loading = false;
                }
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
    },
    methods: {
        validarNombre(){
            this.$v.nombre.$touch();
            const errors = []
            if (this.$v.nombre.$dirty){
                !this.$v.nombre.required && errors.push('Campo requerido.');
                !this.$v.nombre.minLength && errors.push('Mínimo 5 caracteres.');
            }
            this.errors.nombre = errors;
        },
        validarNumero(){
            this.$v.numero.$touch();
            const errors = []
            if (this.$v.numero.$dirty){
                !this.$v.numero.required && errors.push('Campo requerido.');
            }
            this.errors.numero = errors;
        },
        validarPuesto(){
            this.$v.puesto.$touch();
            const errors = []
            if (this.$v.puesto.$dirty){
                !this.$v.puesto.required && errors.push('Campo requerido.');
                !this.$v.puesto.minLength && errors.push('Mínimo 5 caracteres.');
            }
            this.errors.puesto = errors;
        },
        guardarDependencia(){
            this.$v.$touch();
            this.validarNombre();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.post(this.httpURL+'/dependencia',
                { 
                    nombre: this.nombre,
                    tipo: this.tipoSel,
                    numero: this.numero,
                    titular: this.titular, 
                    puesto: this.puesto },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('dependenciaAgregada',{dependencia:res.data.dependencia, log:res.data.log});
                        this.loading = false;
                        this.$notify({ group: 'gral_notif', type:"succsess", duration:1500, speed: 500, text: res.data.mensaje });
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        },
        normalizarTexto(texto) {
            if (!texto) return ""; // Manejar valores nulos o vacíos
            return texto
                .normalize("NFD") // Divide caracteres acentuados
                .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
                .toLowerCase(); // Convierte a minúsculas
        },
        // Filtro personalizado para manejar búsqueda insensible a acentos
        customFilter(item, queryText, itemText) {
            // Normaliza el texto ingresado y el texto del ítem
            const textoBusquedaNormalizado = this.normalizarTexto(queryText);
            const textoItemNormalizado = this.normalizarTexto(itemText);

            // Realiza la comparación
            return textoItemNormalizado.includes(textoBusquedaNormalizado);
        },
    }
}
</script>